const habits = [
  {
    icon: "ri-sun-line",
    title: "每日打卡",
    desc: "记录每一次追瓜,用连续打卡建立稳定的吃瓜节奏,轻松不落下任何瓜。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-eye-2-line",
    title: "蹲更新",
    desc: "锁定你关注的方向,首更即提醒,不用一遍遍刷新也绝不迟到。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-refresh-line",
    title: "定时刷新",
    desc: "自定义早午晚刷新提醒,热榜按时送达,通勤午休睡前各有安排。",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-moon-line",
    title: "睡前必看",
    desc: "睡前五分钟看完当日精选瓜报,清单式梳理,安心入睡不掉队。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-train-wifi-line",
    title: "通勤速览",
    desc: "浓缩晨间瓜报,通勤路上几分钟补完隔夜动态,精神满满开工。",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "习惯养成",
    desc: "把吃瓜变成低负担的日常仪式,少一点焦虑,多一点从容追瓜。",
    color: "bg-accent-100 text-accent-700",
  },
];

export default function Habits() {
  return (
    <section id="habits" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <div className="mb-3 flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-heart-3-line text-lg"></i>
              吃瓜习惯养成
            </div>
            <h2 className="font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
              为什么越追越累?
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              零散刷资讯容易焦虑,还总怕错过关键瓜。吃瓜每日把追瓜拆成一个个顺手的小习惯,
              打卡、蹲更新、定时刷新、通勤速览、睡前必看互相衔接,让你每天都能从容地吃得饱、不掉队。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                "少刷屏多规划,避免信息过载",
                "蹲更新与提醒代替反复刷新",
                "按时段速览,睡前安心不失眠",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {habits.map((h) => (
              <div
                key={h.title}
                className="rounded-2xl bg-background-100 p-5 ring-1 ring-background-200 transition-colors hover:bg-background-50"
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl ${h.color}`}
                >
                  <i className={h.icon}></i>
                </span>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900 md:text-base">
                  {h.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}